module.exports = __webpack_public_path__ + "static/media/hillary2.058a5485.jpg";